import {
  BATCH_INVENTORY_RESULTS_REQUESTED,
  BATCH_INVENTORY_RESULTS_SUCCESS,
  BATCH_INVENTORY_RESULTS_FAILURE,
  BATCH_INVENTORY_DOWNLOAD_REQUESTED,
  BATCH_INVENTORY_DOWNLOAD_SUCCESS,
  BATCH_INVENTORY_DOWNLOAD_FAILURE,
  BATCH_INVENTORY_RESULT_ROW_REQUESTED,
  BATCH_INVENTORY_RESULT_ROW_SUCCESS,
  BATCH_INVENTORY_RESULT_ROW_FAILURE,
  LIVE_INVENTORY_SESSIONS_REQUESTED,
  LIVE_INVENTORY_SESSIONS_SUCCESS,
  LIVE_INVENTORY_SESSIONS_FAILURE,
  DOWNLOAD_SAVED_LIVE_SESSION_REQUESTED,
  DOWNLOAD_SAVED_LIVE_SESSION_SUCCESS,
  DOWNLOAD_SAVED_LIVE_SESSION_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  isDownloading: false,
  status: 'waiting',
  batchResults: [],
  liveResults: [],
  downloadUrl: null,
  errors: null
};

const batchInventoryResults = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  let batch = null;
  let item = null;

  switch(action.type) {
    case BATCH_INVENTORY_RESULTS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        batchResults: [],
        status: 'requesting'
      });

    case BATCH_INVENTORY_RESULTS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        batchResults: action.payload.batchResults,
        errors: null
      });

    case BATCH_INVENTORY_RESULTS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        batchResults: [],
        errors: 'error here'
      });

    case LIVE_INVENTORY_SESSIONS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        liveResults: [],
        status: 'requesting'
      });

    case LIVE_INVENTORY_SESSIONS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        liveResults: action.payload.liveResults,
        errors: null
      });

    case DOWNLOAD_SAVED_LIVE_SESSION_REQUESTED:
      return Object.assign({}, state, {
        isDownloading: true,
        downloadUrl: null,
      });

    case DOWNLOAD_SAVED_LIVE_SESSION_SUCCESS:
      return Object.assign({}, state, {
        isDownloading: false,
        downloadUrl: action.payload.download_url
      });

    case BATCH_INVENTORY_RESULT_ROW_REQUESTED:
      batch = newState.batchResults.find((result) => result.batch_id === action.batchId);
      item = batch.batch_body.items.find((item) => item.action_id === action.actionId);
      item.status = 'fetching';
      return newState;
    
    case BATCH_INVENTORY_RESULT_ROW_SUCCESS:
      batch = newState.batchResults.find((result) => result.batch_id === action.batchId);
      item = batch.batch_body.items.find((item) => item.action_id === action.actionId);

      if(action.payload.actionResult.userErrors.length > 0) {
        item.status = 'error';
        item.error_message = action.payload.actionResult.userErrors[0].message;
      } else {
        item.status = 'success';
        item.actionCompletedAt = action.payload.actionResult.completed_at;
        item.details = action.payload.actionResult.inventoryAdjustmentGroup.changes[0].item.variant;
      }
      return newState;
    

    case BATCH_INVENTORY_RESULT_ROW_FAILURE:
      batch = newState.batchResults.find((result) => result.batch_id === action.batchId);
      item = batch.batch_body.items.find((item) => item.action_id === action.actionId);
      item.status = 'failed';
      item.failure = action.error;
      return newState;

    default:
      return state;
  }
}

export default batchInventoryResults;
